module.exports = __webpack_public_path__ + "static/img/laptop-ela.9f0714c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ela/laptop-ela.jpg
// module id = 0cYb
// module chunks = 1